module.exports = __webpack_public_path__ + "img/iphone_4.0cc04295.png";